import type { HabitatType } from "../monsters/monsterCatalog";

import Obstacle001 from "@assets/imgs/obstacles/001-sea-obstacle.png";
import Obstacle002 from "@assets/imgs/obstacles/002-desert-obstacle.png";
import Obstacle003 from "@assets/imgs/obstacles/003-forest-obstacle.png";
import Obstacle004 from "@assets/imgs/obstacles/004-factory-obstacle.png";
import Obstacle001_fail from "@assets/imgs/obstacles/001-sea-obstacle-fail-fx.png";
import Obstacle002_fail from "@assets/imgs/obstacles/002-desert-obstacle-fail-fx.png";
import Obstacle002_fail2 from "@assets/imgs/obstacles/002-desert-obstacle-fail-fx-2.png";
import Obstacle003_fail from "@assets/imgs/obstacles/003-forest-obstacle-fail-fx.png";
import Obstacle004_fail from "@assets/imgs/obstacles/004-factory-obstacle-fail-fx.png";
import Obstacle004_fail2 from "@assets/imgs/obstacles/004-factory-obstacle-fail-fx-2.png";

// 방해물 설정 인터페이스 및 목록
export interface ObstacleConfig {
  id: string;
  textureKey: string;
  habitat: HabitatType;
}

// 실제 게임에서 사용할 방해물 설정 목록
export const OBSTACLES: ObstacleConfig[] = [
  {
    id: "obstacle-001",
    textureKey: "001-sea-obstacle",
    habitat: "SEA",
  },
  {
    id: "obstacle-002",
    textureKey: "002-desert-obstacle",
    habitat: "DESERT",
  },
  {
    id: "obstacle-003",
    textureKey: "003-forest-obstacle",
    habitat: "FOREST",
  },
  {
    id: "obstacle-004",
    textureKey: "004-factory-obstacle",
    habitat: "FACTORY",
  },
];

// 에셋 로딩  함수
export function preloadObstacles(scene: Phaser.Scene) {
  scene.load.image("001-sea-obstacle", Obstacle001);
  scene.load.image("002-desert-obstacle", Obstacle002);
  scene.load.image("003-forest-obstacle", Obstacle003);
  scene.load.image("004-factory-obstacle", Obstacle004);
  scene.load.spritesheet("001-sea-obstacle-fail", Obstacle001_fail, {
    frameWidth: 256,
    frameHeight: 256,
  });
  scene.load.spritesheet("002-desert-obstacle-fail", Obstacle002_fail, {
    frameWidth: 256,
    frameHeight: 256,
  });
  scene.load.image("002-desert-obstacle-fail-2", Obstacle002_fail2);
  scene.load.spritesheet("003-forest-obstacle-fail", Obstacle003_fail, {
    frameWidth: 1024,
    frameHeight: 200,
  });
  scene.load.image("004-factory-obstacle-fail", Obstacle004_fail);
  scene.load.image("004-factory-obstacle-fail-2", Obstacle004_fail2);
}

// 타입 기반 설정 조회 함수
export function getObstacleById(id: string): ObstacleConfig {
  const found = OBSTACLES.find((obstacle) => obstacle.id === id);

  if (!found) {
    throw new Error(`Unknown obstacle id: ${id}`);
  }

  return found;
}
